var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-alert",
    { staticClass: "bloqueo", attrs: { show: "", variant: "danger" } },
    [
      _vm._v(
        "Ha ocurrido un error, intente nuevamente y caso de persistir comuníquese con soporte técnico"
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }